module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu5mxKOzY.ba2c6cb0.woff2";